// extracted by mini-css-extract-plugin
module.exports = {"similar":"Similar_similar__-5UPg","heading":"Similar_heading__15iMS"};